import React, { useState, useEffect} from 'react';
import EditAddressSearch from './edit-address-search';
import EditAddressDataTable from './edit-address-datatable';
import customerAddressService from '../../services/edit-address/cust-address.service';
import { UserAddressResponseDTO, CustomerAddressModel1 } from '../../models/cust-address/cust-address-model';
import { Dialog } from 'primereact/dialog';
import AddOrEditAddress from '../user-address/add-or-edit-address';
import AddAddress from '../user-address/addresss';
import AppLoading from '../app-loading/app-loading';
import { keyboard } from '@testing-library/user-event/dist/keyboard';

const CustomerAddress: React.FC = () => {
    
    const [userList, setUserList] = useState<CustomerAddressModel1[]>([]);
    const [localFilter, setLocalFilter] = useState<string>(" ");
    const [addAddressUid, setAddAddressUid] = useState<number>(0);
    const [showAddressModal, setShowAddressModal] = useState(false);
    const [currentQuery, setCurrentQuery] = useState<number>(0);
    const [loading, setLoading] = useState(false);

    const [pageNumber, setPageNumber] = useState(1);  
    const [pageSize, setPageSize] = useState(10);     
    const [totalRecords, setTotalRecords] = useState(0);
    

    useEffect(() => {
        fetchData(pageNumber, pageSize);
    }, [currentQuery, localFilter, pageNumber, pageSize]);

    function handRefreshQuery(): void {
        handleSearch(currentQuery);
    }

    function handleSearch(query: number): void {
        setCurrentQuery(query);
        setPageNumber(1);
        fetchData(1, pageSize, query, localFilter);  
    }

    function handleLocalFilter(keyword: string): void {
        setLocalFilter(keyword);
    }

    function handleAddAddress(uid: number): void {
        setAddAddressUid(uid);
        setShowAddressModal(true);
    }

    function handleResetFilters() {
    setLocalFilter("");   // Reset local filter
    setCurrentQuery(0);   // Reset search query
    setPageNumber(1);     // Reset pagination
    fetchData(1, pageSize, 0, ""); // Fetch fresh data
}

      // This function will be triggered when the page changes
      const handlePageChange = (event: { first: number, rows: number }) => {
        const newPageNumber = Math.floor(event.first / event.rows) + 1; // Calculate new page number
        setPageNumber(newPageNumber);
        setPageSize(event.rows); // Update page size as well
        fetchData(newPageNumber, event.rows); // Fetch new data immediately
    };

    const fetchData = async (
    pageNumber: number,
    pageSize: number,
    query: number = currentQuery,
    filter: string = localFilter
) => {
    setLoading(true);
    try {
        let response: UserAddressResponseDTO;

        if (filter.trim() || query) {
            response = await customerAddressService.fetchUserAddresses(
                filter.trim(),
                query,
                pageNumber,
                pageSize
            );
        } else {
            response = await customerAddressService.AllUserAddress(pageNumber, pageSize);
        }
        if (response) {
            setUserList(response.userAddresses);
            setTotalRecords(response.totalRecords);
        }
    } catch (error) {
        console.error("Error fetching address data", error);
    }
    setLoading(false);
};

    const refreshTable = async () => {
    setLoading(true);
    try {
        let response: UserAddressResponseDTO;

        if ((localFilter && localFilter.trim() !== '') || currentQuery !== 0) {
            response = await customerAddressService.fetchUserAddresses(
                localFilter.trim(),
                currentQuery,
                pageNumber,
                pageSize
            );
        } else {
            response = await customerAddressService.AllUserAddress(pageNumber, pageSize);
        }
        if (response) {
            setUserList(response.userAddresses);
            setTotalRecords(response.totalRecords);
        }
    } catch (error) {
        console.error('Error fetching data:', error);
    }
    setLoading(false);
};
    return (
        <>
        <div className="layout-content mt-3 mb-3 grid grid-table-mobile">
            <div className="col-12">                
                <h5 className="ml-1 mb-0">View All Address</h5>
            </div>
            <EditAddressSearch onSearch={handleSearch} onLocalFilter={handleLocalFilter}  setLoading={setLoading}
              addressCount={userList.length}   onAddClick={handleAddAddress}  onReset={handleResetFilters}  />            
            
            <EditAddressDataTable
                    data={userList}
                    filter={localFilter}
                    addAddressCallback={handleAddAddress}
                    pageNumber={pageNumber}
                    pageSize={pageSize}
                    totalRecords={totalRecords} // Pass the total number of records
                    onPageChange={handlePageChange} // Pass page change handler
                    refreshTable={refreshTable}
                />
            <Dialog
                visible={showAddressModal}
                className="quickview w-30rem"
                breakpoints={{ "1400px": "60vw", "641px": "90vw" }}
                modal
                onHide={() => setShowAddressModal(false) }
            >
                <AddOrEditAddress userID={addAddressUid} setHideAddress={setShowAddressModal} RefreshQuery={handRefreshQuery}/>
                {/* <AddAddress userID={addAddressUid} setHideAddress={setShowAddressModal} RefreshQuery={handRefreshQuery}/> */}
            </Dialog>
        </div>
        {loading && <AppLoading />}
        </>
    );
}

export default CustomerAddress;
